import { useRouter } from 'next/router';

export const useGetUrlUuid = () => {
  const router = useRouter();
  return { uuid: typeof router.query.uuid === 'string' ? router.query.uuid : '', router };
};
